const i18n = {
  fallbackLng: 'en',
  supportedLngs: ['en', 'pt', 'es', 'fr', 'ar'],
  defaultNS: 'common',
}

// music_recap_yearly 2025支持的语言列表（60+ 种语言）
// 这些语言仅在 music_recap_yearly 命名空间中使用，不影响其他命名空间
export const musicRecapYearlySupportedLngs = [
  'en',
  'es',
  'pt',
  'fr',
  'ar',
  'zh',
  'az',
  'ta',
  'fa',
  'de',
  'ru',
  'ro',
  'ms',
  'th',
  'tr',
  'it',
  'hi',
  'in',
  'vi',
  'am',
  'et',
  'bg',
  'pl',
  'da',
  'fil',
  'fi',
  'ko',
  'nl',
  'ca',
  'cs',
  'hr',
  'lv',
  'lt',
  'af',
  'ja',
  'sv',
  'sk',
  'sl',
  'sw',
  'uk',
  'he',
  'uz',
  'lo',
  'el',
  'hu',
  'bn',
  'my',
  'km',
  'gu',
  'ur',
  'mr',
  'sr',
  'ka',
  'te',
  'ml',
  'kn',
  'zu',
  'tg',
  'tk',
  'pa-IN',
  'pa-PK',
]

export const NEXT_LOCALE = '__NEXT_LOCALE__'

export default i18n
